import React from 'react';
import ComponentMaintenancePage from '../componentMaintenancePage.js';

const ComponentServiceIncludeMaintenance = ({ i18n }) => {
  return (
    <div
      data-testid="service-include-maintenance"
      className="dodo-service-include__maintenance"
    >
      <div className="ebds-container">
        <div className="ebds-content">
          <ComponentMaintenancePage
            headline={i18n.t('dodo.maintenance.headline')}
            description={i18n.t('dodo.maintenance.description')}
            actionText={i18n.t('dodo.maintenance.actionText')}
            actionUrl="/"
          />
        </div>
      </div>
    </div>
  );
};

export { ComponentServiceIncludeMaintenance };
export default ComponentServiceIncludeMaintenance;
